// GENERATED by scripts/build-virginia-places.mjs from US Census Bureau files. Do not edit by hand.
// Source: U.S. Census Bureau, 2026 Gazetteer Files. See VIRGINIA-PLACES-SOURCE.md beside this file.
// Refresh: npm run places:build
/** The year of the Census Gazetteer Files these rows were built from. */
export const VIRGINIA_PLACES_GAZETTEER_YEAR = 2026;
/** One Virginia city, town or census designated place per line: Census GEOID|name|latitude|longitude. */
export const VIRGINIA_CITY_ROWS = `
5100110|Abbs Valley|37.235392|-81.460147
5100148|Abingdon|36.706665|-81.971627
5100180|Accomac|37.719561|-75.667784
5100468|Adwolf|36.798303|-81.594576
5100484|Afton|38.022163|-78.833446
5100724|Alberta|36.855933|-77.891475
5100772|Aldie|38.97612|-77.647985
5101000|Alexandria|38.818815|-77.083227
5101240|Allison Gap|36.899778|-81.786853
5101256|Allisonia|36.936833|-80.719026
5101416|Alonzaville|38.927751|-78.550927
5101528|Altavista|37.123566|-79.28333
5101640|Amelia Court House|37.335858|-77.986639
5101672|Amherst|37.581894|-79.051995
5101752|Amonate|37.190597|-81.640566
5101912|Annandale|38.832801|-77.196229
5102040|Appalachia|36.912753|-82.795022
5102064|Apple Mountain Lake|38.926685|-78.105138
5102072|Appomattox|37.358738|-78.826446
5102112|Aquia Harbour|38.459234|-77.380104
5102248|Arcola|38.944259|-77.534167
5103000|Arlington|38.878337|-77.100703
5103208|Arrington|37.678696|-78.894759
5103320|Ashburn|39.025434|-77.468773
5103368|Ashland|37.760417|-77.472414
5103512|Atkins|36.866981|-81.398573
5103528|Atlantic|37.903366|-75.506367
5103608|Augusta Springs|38.102962|-79.336345
5103648|Austin Ridge|38.439471|-77.416976
5103656|Austinville|36.851018|-80.914507
5104088|Bailey's Crossroads|38.848458|-77.131005
5104392|Barboursville|38.169924|-78.283603
5104856|Baskerville|36.684407|-78.273196
5104872|Bassett|36.761517|-79.986551
5104904|Bastian|37.153528|-81.152495
5104920|Basye|38.809424|-78.769485
5105200|Bayside|37.754788|-75.712852
5105256|Baywood|36.621889|-81.008466
5105336|Bealeton|38.583015|-77.778763
5105544|Bedford|37.339992|-79.514112
5105912|Belle Haven (Accomack County and Northampton County)|37.554592|-75.828663
5105928|Belle Haven (Fairfax County)|38.777325|-77.057438
5106216|Bellwood|37.406041|-77.436335
5106275|Belmont|39.065619|-77.498473
5106336|Belmont Estates|38.446449|-78.922783
5106424|Belspring|37.195413|-80.612422
5106512|Belview|37.166763|-80.509703
5106712|Benns Church|36.936894|-76.58469
5106728|Bensley|37.447095|-77.444508
5106968|Berryville|39.147726|-77.98016
5107160|Bethel Manor|37.097363|-76.424632
5107400|Big Island|37.532165|-79.362784
5107448|Big Rock|37.35256|-82.18734
5107480|Big Stone Gap|36.86274|-82.776089
5107484|Big Stone Gap East|36.879269|-82.743346
5107784|Blacksburg|37.231264|-80.426745
5107832|Blackstone|37.081822|-78.002812
5107944|Blairs|36.700267|-79.378992
5107976|Bland|37.099492|-81.115765
5108120|Bloxom|37.829241|-75.621437
5108152|Bluefield|37.235225|-81.274659
5108200|Blue Ridge|37.379563|-79.822001
5108264|Blue Ridge Shores|38.109075|-78.020077
5108320|Bobtown|37.649248|-75.799872
5108376|Boissevain|37.275703|-81.385616
5108472|Bon Air|37.516984|-77.570309
5108584|Boones Mill|37.115562|-79.951414
5108675|Boston|37.603856|-75.843711
5108888|Bowling Green|38.053088|-77.347376
5108925|Bowmans Crossing|38.797823|-78.589127
5108984|Boyce|39.093223|-78.060108
5109016|Boydton|36.66606|-78.390727
5109032|Boykins|36.577825|-77.198919
5109064|Bracey|36.57682|-78.106931
5109072|Braddock|38.831875|-77.355031
5109188|Brambleton|38.980243|-77.532796
5109208|Branchville|36.569793|-77.250096
5109248|Brandermill|37.433992|-77.650583
5109352|Brandy Station|38.495045|-77.889951
5109400|Breaks|37.300449|-82.27914
5109656|Bridgewater|38.388484|-78.964468
5109752|Brightwood|38.413954|-78.184695
5109816|Bristol|36.617213|-82.157548
5109952|Broadlands|39.013635|-77.516983
5110040|Broadway|38.608485|-78.801366
5110072|Brodnax|36.702953|-78.031937
5110296|Brookneal|37.047984|-78.953856
5110568|Brucetown|39.252037|-78.064661
5110744|Buchanan|37.520866|-79.691047
5110776|Buckhall|38.715561|-77.447009
5110856|Buckingham Courthouse|37.55589|-78.55138
5111032|Buena Vista|37.729404|-79.35809
5111224|Bull Run (Fairfax County)|38.839703|-77.489496
5111230|Bull Run (Prince William County)|38.780099|-77.520418
5111245|Bull Run Mountain Estates|38.90919|-77.666676
5111464|Burke|38.777716|-77.262594
5111470|Burke Centre|38.791183|-77.300574
5111560|Burkeville|37.187905|-78.194413
5112136|Callaghan|37.809824|-80.089009
5112264|Calverton|38.635169|-77.666433
5112472|Camp Barrett|38.516106|-77.441018
5112590|Camptown|36.685887|-76.894742
5112600|Cana|36.580614|-80.667889
5112808|Cape Charles|37.250842|-76.009662
5112904|Capron|36.709329|-77.201281
5112915|Captains Cove|37.996297|-75.425918
5113160|Carrollton|36.940628|-76.521069
5113192|Carrsville|36.704097|-76.839116
5113403|Cascades|39.047117|-77.387519
5113512|Castlewood|36.880139|-82.295326
5113624|Catlett|38.656381|-77.628856
5113635|Cats Bridge|37.547717|-75.783285
5113720|Cave Spring|37.226543|-80.008077
5113784|Cedar Bluff|37.086956|-81.763725
5114312|Central Garage|37.745797|-77.118307
5114440|Centreville|38.84065|-77.438462
5114544|Chamberlayne|37.627375|-77.428188
5114744|Chantilly|38.88918|-77.442088
5114904|Charles City|37.348306|-77.062955
5114952|Charlotte Court House|37.056247|-78.637687
5114968|Charlottesville|38.037658|-78.485381
5114984|Chase City|36.799844|-78.460951
5114995|Chase Crossing|37.760332|-75.6657
5115000|Chatham|36.812172|-79.400172
5115016|Chatham Heights|38.309647|-77.455712
5115048|Chatmoss|36.675157|-79.795612
5115112|Cheriton|37.294389|-75.965432
5115176|Cherry Hill|38.567902|-77.286336
5116000|Chesapeake|36.679376|-76.301788
5116096|Chester|37.352045|-77.433695
5116240|Chester Gap|38.850109|-78.131581
5116480|Chilhowie|36.800173|-81.682913
5116512|Chincoteague|37.949948|-75.351265
5116608|Christiansburg|37.140663|-80.404512
5116736|Churchville|38.22466|-79.161389
5116880|Claremont|37.227296|-76.966564
5116992|Clarksville|36.616044|-78.564802
5117040|Clary|39.027764|-78.337093
5117120|Claypool Hill|37.064729|-81.749996
5117296|Cleveland|36.943669|-82.152632
5117376|Clifton|38.780128|-77.38599
5117424|Cliftondale Park|37.824938|-79.798136
5117440|Clifton Forge|37.82332|-79.825194
5117504|Clinchco|37.157398|-82.354462
5117536|Clinchport|36.680022|-82.744168
5117552|Clintwood|37.153229|-82.459947
5117632|Clover|36.834682|-78.71628
5117680|Cloverdale|37.348441|-79.896742
5117776|Cluster Springs|36.604519|-78.923099
5117952|Coeburn|36.945648|-82.470398
5118352|Collinsville|36.72102|-79.911638
5118400|Colonial Beach|38.261106|-76.994468
5118428|Colonial Forge|38.423084|-77.458048
5118448|Colonial Heights|37.261685|-77.396804
5118624|Columbia|37.753843|-78.163369
5118656|Columbia Furnace|38.874907|-78.614777
5118880|Concord|37.344841|-78.982888
5118944|Conicville|38.828993|-78.681297
5119560|Countryside|39.051792|-77.41352
5119571|County Center|38.693342|-77.354837
5119592|Courthouse Square|38.418415|-77.413153
5119600|Courtland|36.71226|-77.061957
5119728|Covington|37.78106|-79.985434
5119904|Craigsville|38.086525|-79.390787
5120160|Crewe|37.180994|-78.130407
5120240|Crimora|38.16223|-78.842975
5120436|Crosspointe|38.725152|-77.263024
5120560|Crozet|38.065113|-78.697295
5120752|Culpeper|38.470292|-77.999764
5120768|Cumberland|37.498721|-78.257515
5121008|Dahlgren|38.341976|-77.064267
5121016|Dahlgren Center|38.33604|-77.028895
5121088|Dale City|38.650168|-77.345769
5121152|Daleville|37.41447|-79.913771
5121184|Damascus|36.63267|-81.789359
5121312|Dante|36.984604|-82.283579
5121344|Danville|36.581754|-79.408258
5121648|Dayton|38.417296|-78.941107
5121776|Deep Creek|37.763493|-75.75496
5121872|Deerfield|38.194551|-79.412999
5122064|Deltaville|37.552082|-76.333746
5122160|Dendron|37.036415|-76.924056
5122472|Difficult Run|38.905203|-77.347471
5122560|Dillwyn|37.540511|-78.46121
5122576|Dinwiddie|37.085011|-77.586454
5122640|Disputanta|37.123551|-77.224856
5122976|Dooms|38.100067|-78.850167
5123008|Doran|37.095858|-81.83193
5123376|Drakes Branch|36.993347|-78.60094
5123392|Dranesville|38.996677|-77.370298
5123408|Draper|37.000242|-80.732508
5123584|Dryden|36.775836|-82.944077
5123648|Dublin|37.105503|-80.6897
5123680|Duffield|36.719629|-82.795967
5123732|Dulles Town Center|39.023468|-77.413511
5123744|Dumbarton|37.611887|-77.508285
5123760|Dumfries|38.566115|-77.316052
5123776|Dunbar|36.973257|-82.745885
5123952|Dungannon|36.828397|-82.468108
5123984|Dunn Loring|38.894196|-77.228262
5124208|Eagle Rock|37.642251|-79.791894
5124272|Earlysville|38.154569|-78.468933
5124496|East Highland Park|37.577514|-77.386788
5124544|East Lexington|37.801471|-79.416492
5124720|East Stone Gap|36.865696|-82.743477
5124752|Eastville|37.350999|-75.940768
5124816|Ebony|36.575876|-77.983988
5125008|Edinburg|38.822863|-78.562689
5125136|Eggleston|37.287196|-80.621872
5125408|Elkton|38.41069|-78.616117
5125488|Elliston|37.223236|-80.215439
5125736|Embrey Mill|38.441918|-77.436398
5125792|Emory|36.778883|-81.827435
5125808|Emporia|36.696182|-77.535975
5125848|England Run|38.357037|-77.500843
5125877|Enon|37.327339|-77.321671
5125968|Esmont|37.829168|-78.591981
5126128|Ettrick|37.247306|-77.430756
5126384|Ewing|36.637465|-83.429466
5126416|Exmore|37.529495|-75.828317
5126496|Fairfax|38.853183|-77.299025
5126592|Fairfax Station|38.794835|-77.338545
5126656|Fairfield|37.882818|-79.282871
5126701|Fair Lakes|38.8531|-77.389277
5126736|Fairlawn|37.144193|-80.536508
5126875|Fair Oaks|38.865093|-77.357387
5126944|Fairview|36.829244|-78.465344
5127040|Fairview Beach|38.328167|-77.242346
5127200|Falls Church|38.884722|-77.175603
5127232|Falls Mills|37.279088|-81.306183
5127252|Falls Run|38.358448|-77.488136
5127264|Falmouth|38.330029|-77.462817
5127296|Fancy Gap|36.671266|-80.700997
5127440|Farmville|37.296115|-78.400447
5127712|Ferrum|36.938495|-79.994972
5127736|Ferry Farm|38.294284|-77.43609
5127744|Fieldale|36.700949|-79.942435
5127824|Fincastle|37.501573|-79.874827
5127952|Fishers Hill|38.988629|-78.403498
5127968|Fishersville|38.102349|-78.986163
5128496|Flint Hill|38.765579|-78.103474
5128528|Floris|38.9271|-77.412093
5128544|Floyd|36.91216|-80.318117
5128688|Forest|37.374934|-79.277149
5128848|Forestville|38.714604|-78.72321
5129008|Fort Belvoir|38.713071|-77.144418
5129040|Fort Chiswell|36.94447|-80.957609
5129098|Fort Gregg-Adams|37.235635|-77.332513
5129136|Fort Hunt|38.735462|-77.057664
5129552|Franconia|38.767486|-77.158286
5129600|Franklin|36.684014|-76.941396
5129628|Franklin Farm|38.90979|-77.395913
5129712|Franktown|37.477628|-75.877313
5129744|Fredericksburg|38.299272|-77.486658
5129840|Free Union|38.153302|-78.559039
5129920|Fries|36.715054|-80.977609
5129968|Front Royal|38.924952|-78.183426
5130176|Gainesville|38.793191|-77.642243
5130208|Galax|36.66564|-80.914308
5130384|Gargatha|37.792079|-75.575291
5130480|Gasburg|36.558871|-77.880125
5130496|Gate City|36.646139|-82.578387
5130618|George Mason|38.831513|-77.302406
5131056|Glade Spring|36.789944|-81.772253
5131136|Glasgow|37.631814|-79.458169
5131200|Glen Allen|37.665873|-77.484349
5131376|Glen Lyn|37.372669|-80.858936
5131488|Glenvar|37.276191|-80.126362
5131504|Glen Wilton|37.756032|-79.82184
5131608|Gloucester Courthouse|37.404003|-76.523085
5131616|Gloucester Point|37.271512|-76.498451
5131808|Goochland|37.68791|-77.898044
5131912|Goose Creek Village|39.043103|-77.52544
5131936|Gordonsville|38.135552|-78.187406
5131952|Gore|39.264851|-78.321681
5131968|Goshen|37.98816|-79.504058
5132080|Grafton Village|38.320229|-77.430876
5132320|Gratton|37.134728|-81.426759
5132496|Great Falls|39.011896|-77.301959
5132498|Great Falls Crossing|38.979764|-77.326221
5132560|Greenbackville|38.010003|-75.385368
5132592|Greenbriar|38.871638|-77.399054
5132624|Greenbush|37.73977|-75.679665
5132944|Greenville|38.00345|-79.153862
5133232|Gretna|36.949548|-79.362605
5133488|Grottoes|38.269704|-78.825905
5133584|Groveton|38.749817|-77.107339
5133648|Grundy|37.267165|-82.094455
5133824|Gwynn|37.494903|-76.287417
5134064|Halifax|36.761141|-78.92746
5134176|Hallwood|37.877429|-75.589516
5134240|Hamilton|39.135032|-77.664003
5134304|Hampden-Sydney|37.243178|-78.474648
5135000|Hampton|37.047961|-76.297293
5135035|Hampton Oaks|38.45616|-77.417748
5135160|Hanover|37.772084|-77.375008
5135240|Harborton|37.659599|-75.833227
5135624|Harrisonburg|38.436255|-78.873303
5135640|Harriston|38.208268|-78.82597
5135912|Hayfield|38.753361|-77.132598
5135976|Haymarket|38.812169|-77.636331
5136008|Haysi|37.2159|-82.286741
5136216|Heathsville|37.911474|-76.478551
5136445|Henry Fork|36.96972|-79.870374
5136648|Herndon|38.970412|-77.387073
5137032|Highland Springs|37.551698|-77.327886
5137288|Hillsboro|39.200797|-77.7234
5137336|Hillsville|36.761613|-80.736703
5137380|Hilltown|36.728969|-80.982197
5137432|Hiltons|36.654854|-82.467826
5137544|Hiwassee|36.971902|-80.694928
5137880|Hollins|37.344017|-79.952229
5138032|Hollymead|38.121383|-78.43648
5138280|Honaker|37.015587|-81.968539
5138424|Hopewell|37.29101|-77.298944
5138504|Horntown|37.968829|-75.45729
5138552|Horse Pasture|36.632151|-79.951297
5138632|Hot Springs|38.001289|-79.82389
5138785|Hudson Crossroads|38.794235|-78.726822
5139064|Huntington|38.791196|-77.069795
5139224|Hurt|37.096375|-79.30334
5139259|Hutchison|38.965068|-77.412975
5139304|Hybla Valley|38.746154|-77.079624
5139448|Idylwood|38.889213|-77.204099
5139528|Independence|36.627482|-81.149248
5139544|Independent Hill|38.644549|-77.425113
5139916|Innovation|38.753951|-77.524674
5139920|Innsbrook|37.65368|-77.576459
5140024|Iron Gate|37.798914|-79.790567
5140088|Irvington|37.662372|-76.419998
5140216|Ivanhoe|36.84347|-80.969132
5140232|Ivor|36.901057|-76.894652
5140248|Ivy|38.064999|-78.597394
5140536|Jarratt|36.815991|-77.468911
5141016|Jewell Ridge|37.18577|-81.787371
5141144|Jolivue|38.111145|-79.068295
5141272|Jonesville|36.687112|-83.115313
5141624|Keezletown|38.412823|-78.797659
5141656|Keller|37.621139|-75.764392
5141832|Kenbridge|36.960859|-78.128382
5142104|Keokee|36.862488|-82.913671
5142216|Keswick|38.0145|-78.361573
5142264|Keysville|37.038989|-78.480437
5142424|Kilmarnock|37.714929|-76.388492
5142501|Kincora|39.039035|-77.436642
5142536|King and Queen Court House|37.665122|-76.879333
5142568|King George|38.279436|-77.184308
5142664|Kings Park|38.802169|-77.239334
5142680|Kings Park West|38.814427|-77.295823
5142746|Kingstowne|38.762857|-77.143949
5142792|King William|37.683228|-77.02976
5143176|La Crosse|36.701388|-78.094452
5143224|Lafayette|37.233395|-80.204542
5143348|Lake Arrowhead|38.502185|-77.540025
5143352|Lake Barcroft|38.851553|-77.158743
5143359|Lake Caroline|37.987319|-77.5195
5143392|Lake Holiday|39.306151|-78.327325
5143420|Lake Land'Or|38.017509|-77.553232
5143424|Lake Monticello|37.919875|-78.331791
5143430|Lake of the Woods|38.333765|-77.756465
5143432|Lake Ridge|38.68717|-77.305726
5143464|Lakeside|37.613092|-77.477111
5143600|Lake Wilderness|38.304093|-77.726474
5143704|Lancaster|37.760066|-76.44867
5144048|Lansdowne|39.085271|-77.48374
5144280|Laurel|37.636143|-77.507051
5144430|Laurel Hill|38.705876|-77.243298
5144476|Laurel Park|36.6885|-79.786615
5144520|Lawrenceville|36.7565|-77.853873
5144620|Laymantown|37.364148|-79.86057
5144696|Lebanon|36.899492|-82.078511
5144712|Lebanon Church|39.05588|-78.370546
5144901|Leeland Station|38.336287|-77.435687
5144952|Lee Mont|37.779831|-75.680253
5144984|Leesburg|39.102847|-77.554525
5145008|Leesylvania|38.608262|-77.282893
5145512|Lexington|37.782332|-79.44432
5145784|Lincolnia|38.815789|-77.154271
5145957|Linton Hall|38.753857|-77.578015
5145960|Linville|38.516637|-78.835057
5146328|Loch Lomond|38.780711|-77.482033
5146410|Locust Grove|38.969513|-78.402084
5146456|Locust Mount|37.612415|-75.701735
5146760|Long Branch|38.830539|-77.269975
5147064|Lorton|38.698722|-77.216649
5147136|Loudoun Valley Estates|38.980486|-77.509208
5147144|Louisa|38.016624|-77.999737
5147208|Lovettsville|39.269834|-77.640388
5147224|Lovingston|37.763884|-78.859696
5147296|Lowes Island|39.049173|-77.354761
5147352|Low Moor|37.797907|-79.868961
5147496|Lunenburg|36.958465|-78.268238
5147528|Luray|38.664184|-78.454476
5147672|Lynchburg|37.399069|-79.195294
5147720|Lyndhurst|38.022386|-78.955327
5148184|McDowell|38.341913|-79.505289
5148232|McGaheysville|38.372886|-78.732737
5148344|McKenney|36.985367|-77.721909
5148376|McLean|38.943545|-77.192913
5148445|McMullin|36.818666|-81.577363
5148450|McNair|38.952199|-77.413578
5148488|Madison|38.379354|-78.258598
5148520|Madison Heights|37.450301|-79.10821
5148776|Makemie Park|37.910618|-75.584486
5148856|Mallow|37.76396|-79.969769
5148952|Manassas|38.746808|-77.482633
5148968|Manassas Park|38.769423|-77.440263
5148996|Manchester|37.4891|-77.543893
5149144|Mantua|38.851738|-77.257505
5149320|Mappsburg|37.580467|-75.754901
5149336|Mappsville|37.843366|-75.568752
5149464|Marion|36.837393|-81.515664
5149656|Marshall|38.866012|-77.837107
5149784|Martinsville|36.683527|-79.863647
5149998|Mason Neck|38.651011|-77.170525
5150020|Massanetta Springs|38.397449|-78.830366
5150030|Massanutten|38.411082|-78.727898
5150104|Mathews|37.443256|-76.327722
5150136|Matoaca|37.23232|-77.467494
5150200|Maurertown|38.938982|-78.459568
5150312|Max Meadows|36.97977|-80.961821
5150568|Meadowbrook|37.430467|-77.474494
5150696|Meadows of Dan|36.73863|-80.397378
5150760|Meadowview|36.763709|-81.883535
5150840|Mechanicsburg|37.153269|-80.941822
5150856|Mechanicsville|37.629896|-77.354756
5150984|Melfa|37.648968|-75.740743
5151096|Mendota|36.711121|-82.305688
5151192|Merrifield|38.870304|-77.240352
5151208|Merrimac|37.194867|-80.422012
5151362|Metompkin|37.767122|-75.605423
5151432|Middlebrook|38.06688|-79.233985
5151448|Middleburg|38.973455|-77.745471
5151512|Middletown|39.029093|-78.27778
5151544|Midland|38.598482|-77.718967
5151560|Midlothian|37.484385|-77.649575
5151848|Millboro|37.978509|-79.602209
5152120|Mineral|38.007584|-77.906236
5152408|Modest Town|37.81685|-75.56109
5152536|Moneta|37.188235|-79.613363
5152658|Montclair|38.614249|-77.342057
5152680|Monterey|38.411559|-79.580883
5152904|Montrose|37.521177|-77.374636
5152952|Montross|38.092416|-76.815885
5152968|Montvale|37.385171|-79.725502
5153030|Moorefield|38.998274|-77.492742
5153480|Motley|37.065822|-79.349975
5153584|Mountain Road|36.751607|-78.988225
5153832|Mount Clifton|38.760902|-78.721535
5153864|Mount Crawford|38.362372|-78.941645
5153944|Mount Hermon|36.668844|-79.422149
5153992|Mount Jackson|38.738878|-78.650918
5154056|Mount Olive|38.977974|-78.453412
5154120|Mount Sidney|38.254996|-78.971225
5154144|Mount Vernon|38.713363|-77.105219
5154904|Narrows|37.331479|-80.807427
5154984|Nassawadox|37.476294|-75.859176
5155000|Nathalie|36.938372|-78.944682
5155208|Navy|38.88674|-77.387651
5155400|Nellysford|37.923807|-78.89361
5155448|Nelsonia|37.822459|-75.589492
5155528|New Baltimore|38.735555|-77.72027
5155592|New Castle|37.500992|-80.111017
5155608|New Church|37.983247|-75.529065
5155720|New Hope|38.191685|-78.89478
5155752|Newington|38.734112|-77.19787
5155758|Newington Forest|38.736427|-77.242168
5155800|New Kent|37.509481|-76.986249
5155848|New Market|38.645218|-78.671066
5156000|Newport News|37.076456|-76.520641
5156048|New River|37.142926|-80.595803
5156096|Newsoms|36.626208|-77.124837
5156304|Nickelsville|36.748813|-82.417187
5156464|Nokesville|38.692988|-77.576438
5157000|Norfolk|36.923015|-76.244641
5157368|North Garden|37.962708|-78.631109
5157531|North Shore|37.08322|-79.644559
5157560|North Springfield|38.80285|-77.201073
5157688|Norton|36.931549|-82.625996
5157870|Nottoway Court House|37.127148|-78.071119
5158104|Oak Grove|38.983354|-77.41549
5158184|Oak Hall|37.930782|-75.54691
5158312|Oak Level|36.797229|-79.942919
5158472|Oakton|38.889072|-77.300704
5158696|Occoquan|38.681729|-77.261861
5159336|Onancock|37.709993|-75.74367
5159364|One Loudoun|39.050396|-77.454839
5159384|Onley|37.691325|-75.717141
5159416|Opal|38.615731|-77.8098
5159496|Orange|38.247845|-78.113187
5159672|Orkney Springs|38.794358|-78.816069
5159752|Osaka|36.951465|-82.814429
5160296|Painter|37.585184|-75.783759
5160392|Palmyra|37.866371|-78.257592
5160488|Pamplin City|37.266276|-78.683736
5160512|Pantops|38.032595|-78.444804
5160536|Paris|39.001281|-77.950097
5160666|Park Ridge|38.463051|-77.449685
5160680|Parksley|37.786303|-75.653904
5160840|Parrott|37.214092|-80.629623
5160888|Passapatanzy|38.294631|-77.332207
5160920|Pastoria|37.744993|-75.635769
5160984|Patrick Springs|36.634348|-80.198515
5161208|Pearisburg|37.328683|-80.727293
5161336|Pembroke|37.321876|-80.636501
5161464|Penhook|36.992451|-79.637553
5161560|Pennington Gap|36.757821|-83.035409
5161832|Petersburg|37.20473|-77.392368
5161896|Phenix|37.081059|-78.7485
5162264|Pimmit Hills|38.910532|-77.199144
5162738|Piney Mountain|38.162134|-78.411071
5163190|Plum Creek|37.127098|-80.503373
5163288|Pocahontas|37.309745|-81.34581
5163768|Poquoson|37.12836|-76.303534
5163896|Port Republic|38.284777|-78.812522
5163928|Port Royal|38.164886|-77.199264
5164000|Portsmouth|36.863852|-76.362368
5164152|Potomac Mills|38.656539|-77.29883
5164272|Pound|37.126087|-82.607374
5164288|Pounding Mill|37.07863|-81.712189
5164384|Powhatan|37.542121|-77.927083
5164512|Prices Fork|37.206332|-80.488108
5164560|Prince George|37.220869|-77.268299
5164880|Pulaski|37.05277|-80.761919
5164976|Pungoteague|37.628989|-75.815594
5165008|Purcellville|39.138389|-77.708163
5165120|Quantico|38.522437|-77.290146
5165128|Quantico Base|38.517378|-77.319032
5165248|Quicksburg|38.689969|-78.682249
5165280|Quinby|37.553288|-75.736773
5165392|Radford|37.12012|-80.559149
5165744|Raven|37.093756|-81.859959
5165776|Ravensworth|38.803156|-77.222587
5166032|Rectortown|38.921119|-77.856942
5166512|Remington|38.53461|-77.808178
5166672|Reston|38.951022|-77.350909
5166800|Rhoadesville|38.270757|-77.931614
5166896|Rich Creek|37.384617|-80.818728
5166928|Richlands|37.088039|-81.810425
5167000|Richmond|37.531399|-77.476009
5167208|Ridgeway|36.578174|-79.85829
5167256|Riner|37.067043|-80.440573
5167288|Rio|38.080488|-78.473191
5167304|Ripplemead|37.34005|-80.691274
5167331|Rivanna|37.995279|-78.37884
5167352|Riverdale|36.674848|-78.894011
5167704|Riverview|36.931192|-82.484189
5168000|Roanoke|37.278458|-79.958174
5168470|Rockwood|37.462959|-77.574427
5168480|Rocky Gap|37.240994|-81.107476
5168496|Rocky Mount|37.004398|-79.884762
5168880|Rose Hill (Fairfax County)|38.786948|-77.105691
5168885|Rose Hill (Lee County)|36.664156|-83.373733
5169168|Round Hill|39.131102|-77.770598
5169360|Ruckersville|38.228074|-78.377405
5169456|Rural Retreat|36.905132|-81.27725
5169472|Rushmere|37.071443|-76.670817
5169536|Rustburg|37.272266|-79.100276
5169792|St. Charles|36.805133|-83.057336
5169936|St. Paul|36.906709|-82.317017
5170000|Salem|37.285333|-80.055241
5170096|Saltville|36.875915|-81.762909
5170112|Saluda|37.605274|-76.593798
5170256|Sandston|37.513062|-77.313008
5170296|Sandy Level|36.573681|-79.728236
5170352|Sanford|37.93311|-75.668647
5170480|Saumsville|38.93199|-78.500852
5170520|Savage Town|37.550063|-75.798276
5170528|Savageville|37.682522|-75.759175
5170576|Saxis|37.92648|-75.722973
5170680|Schooner Bay|37.763041|-75.767124
5170704|Schuyler|37.795421|-78.69765
5170715|Scotland|37.181078|-76.796501
5170752|Scottsburg|36.759192|-78.791174
5170800|Scottsville|37.811346|-78.488168
5171040|Sedley|36.776645|-76.990009
5171072|Selma|37.80412|-79.849877
5171216|Seven Corners|38.865522|-77.144814
5171264|Seven Mile Ford|36.815556|-81.632203
5171625|Shawneeland|39.195895|-78.345823
5171632|Shawsville|37.175218|-80.261765
5171776|Shenandoah|38.487131|-78.616451
5171810|Shenandoah Farms|38.97534|-78.047559
5171825|Shenandoah Retreat|39.139346|-77.862643
5171826|Shenandoah Shores|38.962187|-78.14016
5171904|Sherando|37.990092|-78.942483
5172080|Shipman|37.730825|-78.840949
5172272|Short Pump|37.656587|-77.619965
5172736|Singers Glen|38.546544|-78.914404
5172935|Skyland Estates|38.931819|-78.086185
5173200|Smithfield|36.973547|-76.61462
5173376|Snowville|37.021566|-80.579462
5173624|Southampton Meadows|36.591619|-76.929289
5173712|South Boston|36.711825|-78.913354
5173904|South Hill|36.725662|-78.128886
5174100|South Riding|38.911658|-77.513282
5174120|South Run|38.748001|-77.273301
5174160|Southside Chesconessex|37.743966|-75.778684
5174384|Sperryville|38.655516|-78.23608
5174470|Spotsylvania Courthouse|38.199351|-77.59382
5174592|Springfield|38.781571|-77.183921
5174848|Springville|37.187667|-81.390258
5174922|Stafford Lakes Village|38.358655|-77.545774
5175008|Stanardsville|38.299056|-78.436826
5175024|Stanley|38.58104|-78.499404
5175040|Stanleytown|36.751455|-79.952403
5175216|Staunton|38.157978|-79.061876
5175344|Stephens City|39.095801|-78.21702
5175376|Sterling|39.004733|-77.405368
5175440|Stevens Creek|36.731495|-80.994234
5175504|Stewartsville|37.260065|-79.791667
5175536|Stickleyville|36.713329|-82.912188
5175680|Stonega|36.952182|-82.789929
5175702|Stone Ridge|38.925016|-77.555494
5175840|Stony Creek|36.94801|-77.400067
5176000|Strasburg|39.002477|-78.348505
5176256|Stuart|36.640363|-80.268642
5176272|Stuarts Draft|38.018834|-79.034692
5176416|Sudley|38.786984|-77.501479
5176432|Suffolk|36.697157|-76.634781
5176448|Sugar Grove|36.760754|-81.401245
5176464|Sugarland Run|39.033516|-77.368503
5176516|Sully Square|38.921862|-77.426361
5176880|Surry|37.137071|-76.833275
5176912|Sussex|36.917359|-77.271869
5177408|Tacoma|36.935931|-82.531102
5177520|Tangier|37.823436|-75.992811
5177568|Tappahannock|37.910395|-76.867159
5177648|Tasley|37.71245|-75.697033
5177792|Tazewell|37.128862|-81.506308
5177856|Temperanceville|37.907283|-75.557927
5177925|Templeton|37.081004|-77.356322
5178192|The Plains|38.862177|-77.774204
5178264|The University of Virginia's College at Wise|36.97319|-82.55757
5178532|Thynedale|36.818218|-78.477468
5178688|Timberlake|37.317163|-79.246893
5178736|Timberville|38.63266|-78.773717
5179024|Toms Brook|38.946542|-78.440046
5179360|Triangle|38.547151|-77.318494
5179456|Troutdale|36.696071|-81.43756
5179472|Troutville|37.416654|-79.878096
5179560|Tuckahoe|37.58728|-77.588153
5179768|Twin Lakes|38.249804|-78.442772
5179950|Tysons|38.921355|-77.227621
5180000|Union Hall|37.022604|-79.680842
5180016|Union Level|36.707114|-78.231843
5180029|Union Mill|38.801332|-77.387142
5180048|Unionville|38.25779|-77.977077
5180120|University Center|39.062418|-77.445603
5180165|University of Virginia|38.034991|-78.520482
5180224|Upperville|38.991734|-77.881459
5180272|Urbanna|37.638203|-76.57591
5180608|Vansant|37.243163|-82.083779
5180864|Verona|38.195119|-79.010148
5181024|Victoria|36.994444|-78.224298
5181072|Vienna|38.898576|-77.258323
5181152|Villa Heights|36.702171|-79.894608
5181280|Vinton|37.275286|-79.886873
5181312|Virgilina|36.545675|-78.775213
5182000|Virginia Beach|36.779113|-76.02845
5182232|Vista Woods|38.466769|-77.478965
5182320|Wachapreague|37.606415|-75.689273
5182371|Wakefield (Fairfax County)|38.824691|-77.242953
5182384|Wakefield (Sussex County)|36.969126|-76.988096
5183056|Warfield|36.895984|-77.818997
5183088|Warm Springs|38.045045|-79.778695
5183136|Warrenton|38.715376|-77.797563
5183168|Warsaw|37.960312|-76.761188
5183248|Washington|38.711733|-78.159959
5183440|Waterford|39.185174|-77.611896
5183568|Wattsville|37.929099|-75.492534
5183600|Waverly|37.034024|-77.095596
5183680|Waynesboro|38.067157|-78.90142
5183808|Weber City|36.623721|-82.563351
5183888|Weems|37.655038|-76.451237
5184368|West Falls Church|38.865559|-77.187699
5184632|Westlake Corner|37.118625|-79.697907
5184960|West Point|37.552261|-76.801848
5184976|West Springfield|38.775156|-77.224753
5185184|Weyers Cave|38.28006|-78.914162
5185600|White Stone|37.645237|-76.390638
5185608|Whitesville|37.781571|-75.66365
5186160|Williamsburg|37.268945|-76.708655
5186336|Willis Wharf|37.520786|-75.807812
5186720|Winchester|39.173869|-78.176356
5186784|Windsor|36.81119|-76.73841
5187008|Wintergreen|37.911664|-78.930842
5187072|Wise|36.976869|-82.581087
5187240|Wolf Trap|38.937348|-77.282859
5187312|Woodbridge|38.640315|-77.255831
5187333|Woodburn|38.849429|-77.226507
5187380|Woodlake|37.42009|-77.677218
5187408|Woodlawn (Carroll County)|36.738767|-80.809459
5187410|Woodlawn (Fairfax County)|38.732885|-77.11517
5187712|Woodstock|38.872115|-78.51713
5187960|Wyndham|37.692179|-77.610726
5188000|Wytheville|36.953385|-81.088438
5188145|Yogaville|37.667856|-78.689286
5188176|Yorkshire|38.788994|-77.449867
5188240|Yorktown|37.234015|-76.518202
`;
/** One Virginia ZIP code area per line: the five digits|latitude|longitude. */
export const VIRGINIA_ZIP_ROWS = `
20105|38.952448|-77.603575
20106|38.699956|-78.002257
20109|38.793898|-77.530962
20110|38.746071|-77.487673
20111|38.747464|-77.431778
20112|38.673429|-77.430467
20115|38.816301|-77.889615
20117|38.998822|-77.733937
20119|38.62063|-77.625662
20120|38.854716|-77.484033
20121|38.811033|-77.462944
20124|38.781332|-77.391333
20129|39.162682|-77.593317
20130|39.039676|-77.941872
20132|39.165816|-77.726945
20135|39.086311|-77.887216
20136|38.729834|-77.544163
20137|38.806579|-77.722437
20141|39.121273|-77.790941
20143|38.873882|-77.560936
20144|38.920726|-77.935434
20147|39.041947|-77.47813
20148|38.993227|-77.531265
20151|38.896659|-77.443914
20152|38.899353|-77.518706
20155|38.806662|-77.621357
20158|39.139722|-77.658742
20164|39.011103|-77.396849
20165|39.057538|-77.392009
20166|38.948642|-77.472766
20169|38.872078|-77.641384
20170|38.979842|-77.37975
20171|38.926874|-77.396775
20175|39.064401|-77.603762
20176|39.180323|-77.533459
20180|39.268591|-77.637636
20181|38.669109|-77.54957
20184|39.001419|-77.878577
20186|38.687799|-77.839607
20187|38.719678|-77.729897
20190|38.959184|-77.341067
20191|38.933315|-77.350118
20194|38.981041|-77.340785
20197|39.19521|-77.62801
20198|38.884137|-77.744555
22003|38.830261|-77.214454
22015|38.787908|-77.279139
22025|38.591838|-77.349619
22026|38.560349|-77.295999
22027|38.894853|-77.223048
22030|38.837185|-77.34048
22031|38.85955|-77.262692
22032|38.817673|-77.290222
22033|38.875218|-77.384713
22035|38.856315|-77.362851
22039|38.748577|-77.314493
22041|38.849321|-77.141472
22042|38.865143|-77.193913
22043|38.901488|-77.197424
22044|38.862044|-77.154372
22046|38.886334|-77.180975
22060|38.699353|-77.157497
22066|39.011896|-77.301959
22079|38.675396|-77.20397
22101|38.940203|-77.164882
22102|38.951072|-77.229186
22124|38.893769|-77.330216
22125|38.681729|-77.261861
22134|38.532505|-77.405026
22150|38.772863|-77.186523
22151|38.804093|-77.207804
22152|38.774493|-77.232029
22153|38.744969|-77.23564
22172|38.578957|-77.399914
22180|38.895439|-77.256133
22181|38.905545|-77.289778
22182|38.936827|-77.273581
22191|38.622914|-77.262938
22192|38.684218|-77.317942
22193|38.644065|-77.350545
22201|38.886804|-77.094992
22202|38.856869|-77.051492
22203|38.873777|-77.116418
22204|38.860742|-77.098955
22205|38.883371|-77.139537
22206|38.844026|-77.087233
22207|38.906665|-77.124238
22209|38.89443|-77.073406
22211|38.880114|-77.074791
22213|38.894645|-77.162396
22214|38.874906|-77.06505
22301|38.819957|-77.059285
22302|38.827888|-77.083132
22303|38.794263|-77.080699
22304|38.813204|-77.112268
22305|38.836463|-77.062098
22306|38.749817|-77.107339
22307|38.77036|-77.059083
22308|38.729282|-77.060994
22309|38.720336|-77.106155
22310|38.784656|-77.122182
22311|38.833991|-77.125511
22312|38.817531|-77.153866
22314|38.806853|-77.056374
22315|38.756764|-77.147432
22401|38.299272|-77.486658
22405|38.313604|-77.403928
22406|38.399721|-77.54673
22407|38.283532|-77.582519
22408|38.211529|-77.452502
22427|38.072345|-77.28859
22432|37.865645|-76.34595
22433|38.367364|-77.858453
22435|37.966791|-76.572106
22436|38.07744|-77.108153
22437|37.780395|-76.811764
22438|38.044971|-76.992836
22443|38.169514|-76.986805
22448|38.33604|-77.028895
22454|37.834735|-76.842996
22460|37.873557|-76.604492
22469|38.063577|-76.64348
22472|37.958833|-76.672509
22473|37.880469|-76.412955
22476|38.032764|-77.051991
22480|37.662548|-76.412234
22482|37.729357|-76.335402
22485|38.277|-77.16283
22488|38.049455|-76.587481
22503|37.758616|-76.506399
22504|37.775369|-76.714374
22508|38.313139|-77.798419
22509|38.10185|-77.075506
22511|37.976614|-76.493699
22514|38.008001|-77.32938
22520|38.118583|-76.812418
22529|38.011477|-76.68955
22534|38.087247|-77.668986
22535|38.118181|-77.196631
22538|38.192794|-77.27549
22539|37.85597|-76.282961
22542|38.293155|-77.892539
22546|37.944471|-77.446105
22548|37.827225|-76.701525
22551|38.188071|-77.701624
22553|38.271762|-77.640048
22554|38.42068|-77.37468
22556|38.488667|-77.515136
22560|37.915584|-76.961051
22567|38.23743|-77.927663
22572|37.96528|-76.771119
22576|37.689484|-76.45106
22578|37.636877|-76.353624
22580|38.112561|-77.43676
22601|39.17417|-78.173822
22602|39.144249|-78.284807
22603|39.270828|-78.212274
22610|38.824656|-78.279143
22611|39.163065|-77.987209
22620|39.060451|-78.034213
22623|38.849236|-78.142892
22624|39.26121|-78.096282
22625|39.376805|-78.309326
22627|38.772131|-78.145972
22630|38.930927|-78.175855
22637|39.247953|-78.364969
22639|38.845038|-78.034518
22640|38.811028|-78.14057
22641|39.085212|-78.393228
22642|38.948118|-78.027799
22643|38.892758|-78.012721
22644|38.965785|-78.545389
22645|39.019181|-78.274706
22646|39.072517|-78.05093
22650|38.765084|-78.364632
22652|38.840091|-78.431748
22654|39.066244|-78.464028
22655|39.065436|-78.207995
22656|39.219483|-78.100685
22657|39.001087|-78.370608
22660|38.954929|-78.44023
22663|39.052545|-78.11232
22664|38.888919|-78.532453
22701|38.425697|-78.010459
22709|38.328731|-78.213735
22711|38.46032|-78.276158
22712|38.554149|-77.751298
22713|38.533494|-78.135946
22714|38.510253|-77.890506
22715|38.413954|-78.184695
22716|38.62999|-78.103016
22718|38.459898|-77.827949
22719|38.52823|-78.281341
22720|38.480496|-77.648214
22722|38.46625|-78.227059
22723|38.334605|-78.380361
22724|38.631729|-77.903995
22725|38.44051|-78.156075
22726|38.3982|-77.816535
22727|38.407594|-78.295292
22728|38.575006|-77.680261
22729|38.352681|-78.017859
22730|38.362889|-78.16386
22731|38.344129|-78.261453
22732|38.308877|-78.19153
22733|38.321275|-78.040396
22734|38.528612|-77.809749
22735|38.480865|-78.184506
22736|38.398297|-77.694463
22737|38.59205|-78.001812
22738|38.285571|-78.288404
22740|38.64569|-78.286953
22741|38.449608|-77.863964
22742|38.464605|-77.708333
22743|38.54004|-78.381412
22746|38.624179|-78.012941
22747|38.711411|-78.16755
22749|38.619494|-78.184253
22801|38.405147|-78.880723
22802|38.494489|-78.86316
22807|38.43459|-78.86887
22810|38.828302|-78.805972
22811|38.811349|-78.991569
22812|38.378077|-79.02717
22815|38.712509|-78.841209
22820|38.743248|-78.980222
22821|38.480453|-79.128389
22824|38.846712|-78.628319
22827|38.392556|-78.613635
22830|38.667214|-78.974691
22831|38.559898|-79.122141
22832|38.458216|-78.75725
22834|38.55965|-78.854749
22835|38.670431|-78.455301
22840|38.385076|-78.753754
22841|38.341827|-78.892379
22842|38.778048|-78.699661
22843|38.368428|-79.146789
22844|38.661556|-78.658126
22845|38.777881|-78.843935
22846|38.384887|-78.796265
22847|38.718061|-78.713639
22849|38.525324|-78.629627
22850|38.571731|-78.914721
22851|38.543774|-78.503009
22853|38.652361|-78.758714
22901|38.087705|-78.552744
22902|37.910098|-78.521706
22903|38.006988|-78.594993
22904|38.035436|-78.511249
22908|38.030979|-78.496585
22911|38.097005|-78.410147
22920|37.968403|-78.80552
22922|37.685757|-78.921502
22923|38.189313|-78.31668
22931|37.898918|-78.727383
22932|38.147506|-78.696456
22935|38.253962|-78.562656
22936|38.159998|-78.499128
22937|37.814467|-78.612075
22938|37.860653|-78.775381
22939|38.103454|-78.971468
22940|38.210537|-78.594615
22942|38.101443|-78.20213
22943|38.040138|-78.77827
22946|37.847883|-78.563525
22947|38.043989|-78.324721
22948|38.36388|-78.12912
22949|37.789586|-78.883123
22952|37.934282|-79.014199
22957|38.229674|-78.191677
22958|37.893144|-78.894433
22959|37.937273|-78.656561
22960|38.22474|-78.053975
22963|37.846661|-78.293974
22964|37.723829|-78.991072
22967|37.797295|-79.014074
22968|38.241722|-78.393753
22969|37.7975|-78.693372
22971|37.746255|-78.8033
22972|38.217008|-78.233485
22973|38.335462|-78.467868
22974|37.966327|-78.267358
22976|37.848859|-79.045839
22980|38.099837|-78.88055
22989|38.29321|-78.11901
23002|37.349684|-77.959361
23004|37.687541|-78.396568
23005|37.760037|-77.48366
23009|37.811985|-77.175155
23011|37.468465|-76.812469
23015|37.929852|-77.64302
23021|37.400964|-76.371839
23022|37.737052|-78.26416
23023|37.768932|-76.963687
23024|37.927752|-77.779274
23025|37.404817|-76.358505
23027|37.646476|-78.130174
23030|37.345958|-77.055314
23032|37.655493|-76.681949
23035|37.50014|-76.382103
23038|37.753423|-78.148928
23039|37.65288|-77.801578
23040|37.520189|-78.252836
23043|37.556875|-76.344999
23045|37.429301|-76.263794
23047|37.846207|-77.486531
23050|37.487624|-76.422638
23055|37.764979|-78.21474
23056|37.394328|-76.383867
23059|37.702407|-77.573941
23060|37.659664|-77.533827
23061|37.427759|-76.54043
23062|37.26043|-76.502446
23063|37.705919|-77.980663
23065|37.805959|-77.932428
23066|37.494903|-76.287417
23068|37.48976|-76.333362
23069|37.781884|-77.344521
23070|37.547371|-76.384099
23071|37.545187|-76.460853
23072|37.281952|-76.45457
23075|37.557922|-77.317059
23076|37.472417|-76.306619
23079|37.735356|-76.697498
23081|37.19357|-76.752508
23083|37.310661|-78.104834
23084|37.884931|-78.115047
23085|37.688954|-76.825645
23086|37.668573|-77.054414
23089|37.477156|-76.914756
23091|37.656264|-76.802492
23092|37.606782|-76.520113
23093|38.004167|-78.040057
23102|37.708119|-77.828654
23103|37.648036|-77.723641
23106|37.715627|-77.20717
23108|37.656133|-76.720486
23109|37.432539|-76.331543
23110|37.570081|-76.770193
23111|37.613551|-77.243019
23112|37.432553|-77.655051
23113|37.540754|-77.679478
23114|37.48301|-77.660433
23116|37.665476|-77.322001
23117|37.981999|-77.873976
23119|37.450595|-76.273653
23120|37.42208|-77.781371
23123|37.651834|-78.301142
23124|37.55099|-77.044102
23126|37.923335|-77.144173
23128|37.448883|-76.429966
23129|37.703624|-77.777648
23130|37.3908|-76.269036
23138|37.340115|-76.306758
23139|37.545988|-77.936728
23140|37.438755|-77.049272
23141|37.535229|-77.15726
23146|37.723428|-77.710398
23147|37.369636|-77.039114
23148|37.839647|-77.058668
23149|37.575672|-76.609282
23150|37.501199|-77.252081
23153|37.779684|-77.955821
23156|37.51922|-76.726031
23160|37.629084|-77.840754
23161|37.715706|-76.935229
23163|37.358563|-76.299405
23168|37.395688|-76.824933
23169|37.603516|-76.456947
23173|37.575939|-77.542261
23175|37.654932|-76.624457
23176|37.57451|-76.420264
23177|37.728447|-77.007296
23180|37.702428|-76.615265
23181|37.598073|-76.888362
23185|37.239658|-76.701436
23188|37.341605|-76.747782
23192|37.820363|-77.680814
23219|37.540604|-77.434733
23220|37.549349|-77.460606
23221|37.549995|-77.490978
23222|37.582968|-77.418907
23223|37.557767|-77.378886
23224|37.497355|-77.467807
23225|37.519727|-77.510561
23226|37.579356|-77.519937
23227|37.611647|-77.436107
23228|37.626617|-77.492834
23229|37.587876|-77.57019
23230|37.586554|-77.487191
23231|37.442204|-77.314931
23233|37.64324|-77.630084
23234|37.452821|-77.466503
23235|37.51457|-77.564758
23236|37.47581|-77.585285
23237|37.400683|-77.456626
23238|37.592512|-77.641684
23250|37.504696|-77.320853
23284|37.549028|-77.451696
23294|37.631281|-77.542534
23298|37.541707|-77.42953
23301|37.669851|-75.643661
23302|37.862234|-75.517694
23303|37.903366|-75.506367
23304|36.995741|-76.570172
23306|37.566478|-75.885459
23307|37.432039|-75.871157
23308|37.827651|-75.632377
23310|37.257283|-75.957916
23314|36.959049|-76.52428
23315|36.73739|-76.840511
23316|37.294389|-75.965432
23320|36.751734|-76.217637
23321|36.800398|-76.421152
23322|36.625988|-76.267768
23323|36.696998|-76.379915
23324|36.799859|-76.273557
23325|36.813625|-76.239857
23336|37.949432|-75.338084
23337|37.936237|-75.464754
23347|37.357347|-75.978952
23350|37.512704|-75.862589
23354|37.471077|-75.916092
23356|38.010003|-75.385368
23357|37.755646|-75.676028
23358|37.652674|-75.867904
23359|37.887746|-75.604101
23389|37.659432|-75.833378
23395|37.975876|-75.436507
23398|37.520559|-75.939732
23401|37.627758|-75.778349
23405|37.411724|-75.926597
23407|37.847103|-75.554449
23408|37.452913|-75.843474
23409|37.887071|-75.662347
23410|37.63996|-75.744394
23413|37.46237|-75.8495
23414|37.813754|-75.58691
23415|37.975153|-75.535603
23416|37.937326|-75.561481
23417|37.732134|-75.761995
23418|37.641378|-75.668394
23420|37.59907|-75.817482
23421|37.76478|-75.611768
23422|37.636592|-75.826336
23423|37.516077|-75.741043
23426|37.925149|-75.6918
23427|37.899775|-75.718243
23430|36.999357|-76.660769
23432|36.861811|-76.551562
23433|36.916127|-76.484469
23434|36.703904|-76.591905
23435|36.848602|-76.472899
23436|36.893936|-76.503963
23437|36.627115|-76.803197
23438|36.581192|-76.697189
23440|37.825374|-75.990316
23441|37.712102|-75.699413
23442|37.894214|-75.559895
23451|36.872358|-76.004319
23452|36.845812|-76.091964
23453|36.78349|-76.071207
23454|36.864599|-76.055124
23455|36.886051|-76.147283
23456|36.737052|-76.035897
23457|36.617383|-76.015339
23459|36.91681|-76.171748
23460|36.818488|-76.0316
23461|36.770602|-75.963772
23462|36.836242|-76.145948
23464|36.796917|-76.187631
23480|37.618681|-75.690659
23486|37.520786|-75.807812
23487|36.847368|-76.725048
23488|37.947613|-75.598459
23502|36.860586|-76.204883
23503|36.948786|-76.266459
23504|36.857302|-76.265612
23505|36.912882|-76.299596
23507|36.864564|-76.303218
23508|36.885284|-76.310337
23509|36.882473|-76.263939
23510|36.852414|-76.29148
23511|36.937399|-76.309032
23513|36.889281|-76.236939
23517|36.869238|-76.292055
23518|36.916118|-76.215375
23523|36.830857|-76.27226
23551|36.923536|-76.292547
23601|37.037807|-76.479769
23602|37.113416|-76.517947
23603|37.191057|-76.564535
23604|37.119123|-76.593192
23605|37.01867|-76.436702
23606|37.062705|-76.517837
23607|36.969683|-76.421938
23608|37.147813|-76.543036
23651|37.001732|-76.306783
23661|37.003434|-76.360161
23662|37.133238|-76.355021
23663|37.015912|-76.322526
23664|37.073116|-76.295078
23665|37.083989|-76.360136
23666|37.057009|-76.408083
23667|37.02201|-76.329688
23668|37.020264|-76.338549
23669|37.050708|-76.339274
23681|37.096813|-76.383535
23690|37.220291|-76.518326
23691|37.259622|-76.572884
23692|37.212226|-76.421272
23693|37.130997|-76.44272
23696|37.187709|-76.413682
23701|36.811975|-76.369378
23702|36.803271|-76.326721
23703|36.893339|-76.373292
23704|36.826697|-76.312032
23707|36.841794|-76.340331
23708|36.847681|-76.304081
23709|36.817213|-76.298849
23801|37.23613|-77.335804
23803|37.211842|-77.480927
23805|37.136409|-77.393183
23821|36.883194|-77.91295
23824|37.088778|-77.958041
23827|36.619049|-77.200186
23828|36.580854|-77.266933
23829|36.727283|-77.228414
23830|37.024337|-77.397215
23831|37.345595|-77.449802
23832|37.387809|-77.591359
23833|37.211309|-77.666413
23834|37.290074|-77.40078
23836|37.351843|-77.330306
23837|36.758218|-77.090401
23838|37.317516|-77.633869
23839|37.085921|-76.918457
23840|37.051048|-77.671109
23841|37.061708|-77.554223
23842|37.13718|-77.217028
23843|36.850366|-77.811813
23844|36.678269|-77.328133
23845|36.577278|-77.977337
23846|37.066603|-76.83402
23847|36.664183|-77.55164
23850|37.159241|-77.738597
23851|36.652023|-76.957141
23856|36.794321|-77.703117
23857|36.584651|-77.883799
23860|37.274749|-77.227409
23866|36.923676|-76.862401
23867|36.820372|-77.488594
23868|36.710446|-77.789872
23870|36.752475|-77.500167
23872|36.982977|-77.726757
23874|36.584733|-77.070769
23875|37.230004|-77.255836
23876|36.955|-77.832706
23878|36.824772|-77.025432
23879|36.592275|-77.596839
23881|37.180741|-76.977829
23882|36.926173|-77.421687
23883|37.135962|-76.735892
23884|36.917319|-77.280089
23885|37.176606|-77.569502
23887|36.57143|-77.813066
23888|36.9543|-76.979206
23889|36.903562|-77.747962
23890|37.009176|-77.118319
23891|37.047636|-77.203719
23893|36.624444|-77.936561
23894|37.137093|-77.824648
23897|36.83731|-77.284758
23898|36.836029|-76.863148
23899|37.230479|-76.966153
23901|37.320056|-78.409678
23909|37.298993|-78.396307
23915|36.69314|-78.287418
23917|36.625554|-78.344856
23919|36.580647|-78.135051
23920|36.725686|-77.971076
23921|37.586633|-78.62318
23922|37.174829|-78.221739
23923|37.087148|-78.649692
23924|36.822185|-78.425844
23927|36.578574|-78.548388
23930|37.171003|-78.099611
23934|37.177077|-78.626671
23936|37.524599|-78.476528
23937|36.943082|-78.51826
23938|36.904221|-78.006223
23942|37.129727|-78.298581
23943|37.24321|-78.462039
23944|36.915932|-78.138604
23947|37.019052|-78.449277
23950|36.660736|-78.07527
23952|36.917525|-78.279219
23954|37.106332|-78.380046
23955|37.1126|-78.069867
23958|37.27396|-78.65694
23959|37.105192|-78.794749
23960|37.320962|-78.552064
23962|36.950635|-78.692391
23963|37.209474|-78.79027
23964|36.782735|-78.633141
23966|37.300262|-78.259116
23967|36.922093|-78.631377
23968|36.717744|-78.510834
23970|36.739109|-78.182448
23974|36.969804|-78.240947
23976|36.855538|-78.5791
24011|37.270198|-79.941523
24012|37.316508|-79.895102
24013|37.267389|-79.921908
24014|37.22286|-79.915191
24015|37.253074|-79.983552
24016|37.272053|-79.954991
24017|37.29808|-79.990259
24018|37.213441|-80.040879
24019|37.343945|-79.954546
24020|37.356121|-79.943191
24022|37.276862|-79.934277
24053|36.612692|-80.536197
24054|36.681877|-79.698115
24055|36.760219|-80.002627
24058|37.175563|-80.621845
24059|37.155906|-80.131958
24060|37.260401|-80.416864
24061|37.22582|-80.426238
24064|37.376311|-79.770395
24065|37.117076|-79.9969
24066|37.536095|-79.678578
24067|37.02903|-80.057792
24069|36.576864|-79.642639
24070|37.37208|-80.232827
24072|37.041992|-80.242334
24073|37.134604|-80.422988
24076|36.603495|-80.419567
24077|37.360992|-79.907974
24078|36.724265|-79.913147
24079|37.053355|-80.150755
24082|36.633398|-80.135437
24083|37.405334|-79.920453
24084|37.167585|-80.717608
24085|37.68393|-79.857319
24086|37.27558|-80.632246
24087|37.221511|-80.23893
24088|36.887904|-80.077927
24089|36.703913|-79.960775
24090|37.530182|-79.895504
24091|36.919838|-80.321295
24092|37.012031|-79.757851
24093|37.383953|-80.860569
24095|37.223046|-79.736902
24101|37.173555|-79.796387
24102|36.844404|-80.002271
24104|37.133558|-79.488713
24105|36.911577|-80.603687
24112|36.72278|-79.844647
24120|36.693781|-80.410112
24121|37.168889|-79.647386
24122|37.426197|-79.69213
24124|37.305928|-80.866008
24127|37.447136|-80.290181
24128|37.339994|-80.482544
24129|37.139573|-80.591735
24131|37.570649|-80.23287
24132|37.203757|-80.659289
24133|36.675633|-80.127964
24134|37.247923|-80.777561
24136|37.310641|-80.627567
24137|36.927552|-79.657504
24138|37.051815|-80.31735
24139|37.040091|-79.436407
24141|37.106308|-80.562446
24142|37.138197|-80.550803
24147|37.40104|-80.818656
24148|36.581492|-79.876777
24149|37.018582|-80.433581
24150|37.401049|-80.598275
24151|36.961473|-79.866281
24153|37.30343|-80.113127
24161|36.978085|-79.529113
24162|37.129449|-80.249715
24165|36.594294|-80.060622
24167|37.255259|-80.724536
24168|36.736039|-79.948755
24171|36.698799|-80.222353
24174|37.34972|-79.661897
24175|37.4577|-80.029375
24176|37.005545|-79.692495
24179|37.282958|-79.793851
24184|37.087129|-79.773642
24185|36.808689|-80.275573
24201|36.60714|-82.171056
24202|36.65631|-82.212219
24210|36.768935|-82.027531
24211|36.654681|-81.954003
24216|36.943624|-82.782796
24217|37.102112|-82.170381
24219|36.834418|-82.74906
24220|37.121879|-82.223096
24221|36.62531|-82.998742
24224|36.861213|-82.271547
24225|36.991715|-82.141853
24226|37.136882|-82.32303
24228|37.166745|-82.456364
24230|36.968669|-82.451369
24236|36.638506|-81.7245
24237|37.040636|-82.261885
24239|37.113037|-82.147305
24243|36.784269|-82.919771
24244|36.707699|-82.803361
24245|36.838011|-82.512802
24246|36.866168|-82.743949
24248|36.60958|-83.50984
24250|36.756607|-82.588482
24251|36.657375|-82.598935
24256|37.223339|-82.283532
24258|36.649232|-82.408651
24260|37.021059|-82.001115
24263|36.668239|-83.167116
24265|36.832761|-82.946505
24266|36.86802|-82.101925
24269|37.072772|-82.380679
24270|36.72961|-82.250673
24271|36.748813|-82.417187
24272|37.017808|-82.333371
24273|36.964701|-82.66148
24277|36.749404|-83.019324
24279|37.077737|-82.627316
24280|36.954813|-81.943423
24281|36.637323|-83.340226
24282|36.833535|-83.064928
24283|36.939782|-82.332939
24290|36.616104|-82.561338
24292|36.624744|-81.595528
24293|36.99724|-82.566559
24301|37.065021|-80.818205
24311|36.872888|-81.402925
24312|36.833039|-80.886948
24313|36.911185|-80.795743
24314|37.157244|-81.210414
24315|37.133608|-81.063255
24316|36.955705|-81.668988
24317|36.601171|-80.671355
24318|36.995958|-81.387124
24319|36.761741|-81.65692
24322|36.799014|-81.113662
24323|36.86577|-81.204727
24324|36.974112|-80.776478
24325|36.810406|-80.587633
24326|36.722732|-81.190257
24327|36.773635|-81.829717
24328|36.645297|-80.700813
24330|36.715854|-81.026821
24333|36.639974|-80.934776
24340|36.753252|-81.767904
24343|36.761869|-80.705014
24347|36.960871|-80.652471
24348|36.652374|-81.215787
24350|36.81331|-80.994157
24351|36.575342|-80.765015
24352|36.709011|-80.531193
24354|36.821272|-81.540457
24360|36.940631|-80.909054
24361|36.767327|-81.845109
24363|36.61663|-81.405048
24366|37.277353|-81.055455
24368|36.892705|-81.297991
24370|36.907408|-81.662838
24374|36.783891|-81.220639
24375|36.769042|-81.387326
24377|37.002115|-81.568654
24378|36.694311|-81.419636
24380|36.859701|-80.508764
24381|36.726552|-80.837527
24382|36.95331|-81.110754
24401|38.134387|-79.085564
24411|38.118186|-79.330583
24412|38.053722|-79.818136
24413|38.505863|-79.556099
24415|37.9097|-79.308693
24416|37.728717|-79.354893
24421|38.244658|-79.245109
24422|37.832856|-79.750441
24426|37.759144|-80.043176
24430|38.077977|-79.34309
24431|38.170167|-78.843037
24432|38.148358|-79.443533
24433|38.424003|-79.425107
24435|37.857657|-79.306951
24437|38.21248|-78.933724
24439|38.017042|-79.482049
24440|37.999339|-79.165281
24441|38.222233|-78.809436
24442|38.37253|-79.384617
24445|37.960056|-79.871801
24448|37.797528|-79.788813
24450|37.784436|-79.539763
24457|37.795646|-79.865147
24458|38.32643|-79.510303
24459|38.039279|-79.279523
24460|38.016947|-79.666635
24464|37.860625|-79.109957
24465|38.402175|-79.646751
24467|38.254996|-78.971225
24469|38.200975|-78.908253
24471|38.31321|-78.78418
24472|37.943606|-79.217203
24473|37.934747|-79.415358
24474|37.805299|-79.847564
24476|37.974466|-79.227361
24477|38.005228|-79.04226
24479|38.165107|-79.243439
24482|38.203643|-78.998695
24483|37.812635|-79.235167
24484|38.183081|-79.799492
24485|38.270936|-79.32998
24486|38.297022|-78.924353
24487|38.199727|-79.588455
24501|37.359868|-79.141522
24502|37.355181|-79.218728
24503|37.45433|-79.241378
24504|37.365249|-79.048192
24515|37.351907|-79.180116
24517|37.141628|-79.237169
24520|36.586589|-79.029748
24521|37.633292|-79.10084
24522|37.376791|-78.778773
24523|37.336882|-79.525726
24526|37.556164|-79.397558
24527|36.732729|-79.345561
24528|37.079686|-78.876229
24529|36.617245|-78.629806
24530|36.806655|-79.619725
24531|36.842667|-79.440153
24534|36.884138|-78.769279
24536|37.490862|-79.32367
24538|37.379013|-78.97006
24539|36.840575|-78.931411
24540|36.634506|-79.426756
24541|36.589484|-79.515482
24549|36.706651|-79.504501
24550|37.23814|-79.272262
24551|37.370069|-79.331363
24553|37.545572|-78.810049
24554|37.118652|-79.072363
24555|37.666966|-79.468292
24556|37.375825|-79.399305
24557|36.969893|-79.306107
24558|36.780645|-78.956102
24562|37.703198|-78.617799
24563|37.06178|-79.277634
24565|36.85272|-79.189501
24566|36.733605|-79.258704
24569|37.042552|-79.125855
24570|37.34859|-79.427169
24571|37.132961|-79.372749
24572|37.464619|-79.09336
24574|37.576927|-79.245595
24577|36.943933|-78.982674
24578|37.659882|-79.56228
24579|37.586238|-79.503033
24580|36.579054|-78.673121
24581|37.655216|-78.805765
24586|36.606963|-79.276573
24588|37.262308|-79.096378
24589|36.757223|-78.753722
24590|37.792821|-78.474856
24592|36.681952|-78.9527
24593|37.331052|-78.913291
24594|36.635983|-79.186729
24595|37.561245|-79.080662
24597|36.782411|-79.110858
24598|36.60467|-78.788004
24599|37.614736|-78.729931
24601|37.190597|-81.640566
24602|37.183213|-81.65851
24603|37.347416|-82.203222
24604|37.211983|-81.539669
24605|37.23822|-81.360362
24606|37.289353|-81.391205
24607|37.29548|-82.270862
24609|37.016058|-81.791386
24612|37.100232|-81.849034
24613|37.265157|-81.336881
24614|37.312854|-82.087227
24620|37.427427|-82.004802
24622|37.214674|-81.789852
24630|37.176299|-81.47659
24631|37.221713|-82.001735
24634|37.267446|-81.903273
24635|37.3079|-81.348777
24637|37.0611|-81.713916
24639|37.174202|-81.90236
24641|37.111812|-81.802438
24646|37.144822|-82.024221
24649|37.090347|-81.921695
24651|37.075529|-81.503095
24656|37.181887|-82.108344
24657|37.227814|-81.848776
`;
//# sourceMappingURL=virginia-places.generated.js.map